import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { ApiClientService } from '../../shared/api-client.service';

@Injectable()
export class MunicipalityCodeSelectionService {
  onSelectionChange: EventEmitter<boolean> = new EventEmitter(true);

  isMissingData = false;
  selection = new BehaviorSubject<any>({
    code: null,
    location: null,
    region: null,
    missingData: null
  });

  private selectedCode: Number;
  private selectedLocation: string;
  private selectedRegion: string;

  private missingDataEndpoint = '/user/municipality_check?municipality_code=';

  constructor(private apiClientService: ApiClientService) {}

  public getSelectedCode() {
    return this.selectedCode;
  }

  public getSelectedLocation() {
    return this.selectedLocation;
  }

  public getSelectedRegion() {
    return this.selectedRegion;
  }

  public setSelection(code: number, location: string, region: string) {
    const firstLoad: boolean = this.selection.getValue()['code'] === null;
    if (!firstLoad) this.onSelectionChange.emit(false);
    this.isMissingData = false;
    this.selectedCode = code;
    this.selectedLocation = location;
    this.selectedRegion = region;
    this.apiClientService
      .get(this.missingDataEndpoint + code.toString())
      .subscribe((data: any) => {
        this.isMissingData = data.missingData;
        this.selection.next({
          code: code,
          location: location,
          region: region,
          missingData: data.missingData
        });
        if (!firstLoad) this.onSelectionChange.emit(true);
      });
  }

  public resetSelection() {
    this.selection.next({
      code: null,
      location: null,
      region: null,
      missingData: null
    });
  }

  public requestDataForSelectedMunicipality(context) {
    const ngUnsubscribe: Subject<void> = new Subject<void>();
    this.selection.takeUntil(ngUnsubscribe).subscribe((selection: any) => {
      context.isFetching = true;
      if (selection.code && selection.location && selection.region) {
        context.prepareData();
        ngUnsubscribe.next();
        ngUnsubscribe.complete();
      }
    });
  }
}
